// b.ring theme v10 — theme.js

// ── Theme toggle ──
function toggleTheme() {
  var t = document.documentElement.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
  document.documentElement.setAttribute('data-theme', t);
  localStorage.setItem('bring-theme', t);
  updateToggleIcon(t);
}
function updateToggleIcon(t) {
  var btn = document.getElementById('theme-toggle');
  if (!btn) return;
  btn.innerHTML = t === 'dark'
    ? '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg>'
    : '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>';
}

document.addEventListener('DOMContentLoaded', function () {

  // ── Init theme ──
  var t = localStorage.getItem('bring-theme') || 'light';
  document.documentElement.setAttribute('data-theme', t);
  updateToggleIcon(t);

  // ── Scroll reveal ──
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('vis');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.05, rootMargin: '0px 0px -28px 0px' });
    document.querySelectorAll('.rv').forEach(function (el) { io.observe(el); });
  } else {
    // fallback: show all immediately
    document.querySelectorAll('.rv').forEach(function (el) { el.classList.add('vis'); });
  }

  // ── Sticky buy button ──
  var stickyBtn = document.getElementById('sticky-buy');
  if (stickyBtn) {

    var footer = document.querySelector('footer, .site-footer, #shopify-section-footer');
    window.addEventListener('scroll', function () {
      var scrollY = window.scrollY;
      var headerH = 56;
      var pastHeader = scrollY > headerH;
      var footerVisible = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      stickyBtn.classList.toggle('show', pastHeader && !footerVisible);
    }, { passive: true });
  }

  // 説明サブテキストの1行目（<br>より前）を自動で太字にする
  function subBold(h){
    if(!h) return h;
    var i = h.search(/<br\s*\/?>/i);
    return i === -1 ? '<b>'+h+'</b>' : '<b>'+h.slice(0,i)+'</b>'+h.slice(i);
  }
  // ── Product swatches: material + color + price ──
  document.querySelectorAll('.prod-card').forEach(function (card) {
    // 最初のimgのdata-matを初期値に（Proはtitaniumのみなので正しく動く）
    var firstImg = card.querySelector('.prod-img-wrap img');
    var currentMat   = (firstImg && firstImg.dataset.mat) ? firstImg.dataset.mat : 'stainless';
    var currentColor = 'silver';
    var prices = {};
    try { prices = JSON.parse(card.dataset.prices || '{}'); } catch (e) {}
    var _initSub = card.querySelector('.prod-sub');
    if (_initSub) _initSub.innerHTML = subBold(_initSub.innerHTML);

    function getImg(mat, color) {
      var imgs = card.querySelectorAll('.prod-img-wrap img');
      var model = card.dataset.model || null;
      var found = null;
      // モデル指定がある場合は、現在のモデルに一致する画像を優先
      if (model) {
        imgs.forEach(function (img) {
          if (!found && img.dataset.model === model && img.dataset.mat === mat && img.dataset.color === color) found = img;
        });
        if (!found) imgs.forEach(function (img) {
          if (!found && img.dataset.model === model && img.dataset.mat === mat) found = img;
        });
        if (found) return found;
      }
      imgs.forEach(function (img) {
        if (!found && img.dataset.mat === mat && img.dataset.color === color) found = img;
      });
      if (!found) imgs.forEach(function (img) {
        if (!found && img.dataset.mat === mat) found = img;
      });
      return found || imgs[0];
    }

    function syncSwatches(mat) {
      card.querySelectorAll('.swatch[data-color]').forEach(function (sw) {
        var allow = sw.dataset.mats;
        var ok = !allow || allow.split(' ').indexOf(mat) > -1;
        sw.classList.toggle('is-off', !ok);
      });
    }

    function firstColorFor(mat) {
      var found = null;
      card.querySelectorAll('.swatch[data-color]').forEach(function (sw) {
        if (found) return;
        var allow = sw.dataset.mats;
        if (!allow || allow.split(' ').indexOf(mat) > -1) found = sw;
      });
      return found;
    }

    function activate(mat, color) {
      currentMat   = mat;
      currentColor = color;
      syncSwatches(mat);
      card.querySelectorAll('.prod-img-wrap img').forEach(function (i) { i.classList.remove('active'); });
      var target = getImg(mat, color);
      if (target) target.classList.add('active');
      var priceEl = card.querySelector('.prod-price');
      var priceKey = (color === 'blue' && prices['blue']) ? 'blue' : mat;
      var saleData = null;
      if (card.dataset.sale) { try { saleData = JSON.parse(card.dataset.sale); } catch (e) { saleData = null; } }
      var saleKey = (color === 'blue') ? 'blue' : mat;
      var saleItem = null;
      if (saleData && saleData.items && saleData.items[saleKey] && card.dataset.model !== 'g1s') {
        var _end = saleData.end ? new Date(saleData.end).getTime() : Infinity;
        if (Date.now() < _end) { saleItem = saleData.items[saleKey]; }
      }
      if (priceEl && prices[priceKey]) {
        priceEl.style.transition = 'opacity 0.35s ease';
        priceEl.style.opacity = '0';
        setTimeout(function () {
          if (saleItem) {
            priceEl.innerHTML =
              '<span style="font-size:11px;font-weight:500;color:#c0392b;display:block;margin-bottom:2px">' + saleData.label + '</span>' +
              '<span style="display:flex;align-items:center;gap:8px;flex-wrap:wrap">' +
                '<span style="color:#c0392b">' + saleItem.sale + '</span>' +
                '<span style="font-size:13px;font-weight:500;color:var(--ink-4);text-decoration:line-through">' + saleItem.regular + '</span>' +
                '<span style="font-size:12px;font-weight:500;padding:2px 7px;border-radius:4px;background:#fdecea;color:#c0392b">' + saleItem.off + '</span>' +
              '</span>';
          } else {
            priceEl.innerHTML = prices[priceKey];
          }
          priceEl.style.opacity = '1';
        }, 350);
      }
      var buyBtn = card.querySelector('.prod-buy-btn');
      if (buyBtn && buyBtn.dataset.urls) {
        try {
          var urls = JSON.parse(buyBtn.dataset.urls);
          var urlKey = (color === 'blue') ? 'blue' : mat;
          if (urls[urlKey]) buyBtn.dataset.currentUrl = urls[urlKey];
          else if (urls[mat]) buyBtn.dataset.currentUrl = urls[mat];
        } catch(e) {}
      }
      // 左上のバッジは出さない（右上を COLLAB に切り替えるため）
      var existingBadge = card.querySelector('.prod-limited-badge');
      if (existingBadge) existingBadge.remove();
      // 受賞バッジは対象素材のときだけ出す（data-award-mat で指定）
      var award = card.querySelector('.prod-award');
      if (award) {
        var need = award.dataset.awardMat;
        award.style.display = (!need || need === mat) ? '' : 'none';
      }
      // ブルーのときは右上バッジを COLLAB に差し替える
      var mainBadge = card.querySelector('.prod-badge');
      if (mainBadge) {
        if (!mainBadge.dataset.base) mainBadge.dataset.base = mainBadge.textContent;
        mainBadge.textContent = (color === 'blue') ? 'COLLAB' : mainBadge.dataset.base;
      }
    }

    // mat pills
    card.querySelectorAll('.mat-pill[data-mat]').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var m = this.dataset.mat;
        card.querySelectorAll('.mat-pill').forEach(function (p) { p.classList.remove('active'); });
        this.classList.add('active');
        var col = currentColor;
        var cur = card.querySelector('.swatch[data-color="' + col + '"]');
        var allow = cur && cur.dataset.mats;
        if (allow && allow.split(' ').indexOf(m) === -1) {
          var next = firstColorFor(m);
          if (next) {
            card.querySelectorAll('.swatch[data-color]').forEach(function (s2) { s2.classList.remove('active'); });
            next.classList.add('active');
            var lbl = card.querySelector('.swatch-name');
            if (lbl) lbl.textContent = next.dataset.colorName || next.title || '';
            col = next.dataset.color;
          }
        }
        activate(m, col);
      });
    });

    // color swatches
    card.querySelectorAll('.swatch[data-color]').forEach(function (sw) {
      sw.addEventListener('mouseenter', function () {
        var row = this.closest('.swatch-row');
        if (row) row.querySelectorAll('.swatch').forEach(function (s) { s.classList.remove('active'); });
        this.classList.add('active');
        var lbl = this.closest('.swatch-group') && this.closest('.swatch-group').querySelector('.swatch-name');
        if (lbl) lbl.textContent = this.dataset.colorName || this.title || '';
        var swMats = this.dataset.mats;
        var useMat = currentMat;
        if (swMats && swMats.split(' ').indexOf(useMat) === -1) {
          useMat = swMats.split(' ')[0];
          card.querySelectorAll('.mat-pill[data-mat]').forEach(function (p) {
            p.classList.toggle('active', p.dataset.mat === useMat);
          });
        }
        activate(useMat, this.dataset.color);
      });
    });

    // 購入ボタン クリック
    card.querySelectorAll('.prod-buy-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var url = this.dataset.currentUrl;
        if (url) window.location.href = url;
      });
    });

    // model toggle (G1 / G1S)
    var modelToggle = card.querySelector('.model-toggle');
    if (modelToggle) {
      modelToggle.querySelectorAll('.mt-btn[data-model]').forEach(function (mb) {
        mb.addEventListener('click', function () {
          var model = this.dataset.model;
          if (card.dataset.model === model) return;
          card.dataset.model = model;
          modelToggle.setAttribute('data-active', model);
          modelToggle.querySelectorAll('.mt-btn').forEach(function (b) { b.classList.remove('active'); });
          this.classList.add('active');
          var data = {};
          try { data = JSON.parse(card.dataset['model' + (model === 'g1s' ? 'G1s' : 'G1')] || '{}'); } catch (e) {}
          var nameEl = card.querySelector('.prod-name');
          var subEl  = card.querySelector('.prod-sub');
          if (nameEl && data.name) nameEl.textContent = data.name;
          if (subEl && data.sub) subEl.innerHTML = subBold(data.sub);
          if (data.prices) { prices = data.prices; card.dataset.prices = JSON.stringify(data.prices); }
          var bb = card.querySelector('.prod-buy-btn');
          if (bb && data.urls) bb.dataset.urls = JSON.stringify(data.urls);
          if (bb) {
            var bspan = bb.querySelector('span');
            if (bspan && data.btn) bspan.textContent = data.btn;
            if (data.reserve) bb.classList.add('is-reserve');
            else bb.classList.remove('is-reserve');
          }
          activate(currentMat, currentColor);
        });
      });
    }

    // init
    var initPill = card.querySelector('.mat-pill.active');
    if (initPill && initPill.dataset.mat) currentMat = initPill.dataset.mat;
    activate(currentMat, currentColor);
  });

  // ── Gallery thumbnails ──
  document.querySelectorAll('.gal-th').forEach(function (th) {
    th.addEventListener('click', function () {
      var main = document.getElementById('gal-main-img');
      if (main && this.dataset.src) main.src = this.dataset.src;
      document.querySelectorAll('.gal-th').forEach(function (x) { x.classList.remove('on'); });
      this.classList.add('on');
    });
  });

  // ── Variant pills ──
  document.querySelectorAll('.var-pills').forEach(function (g) {
    g.querySelectorAll('.var-pill').forEach(function (p) {
      p.addEventListener('click', function () {
        g.querySelectorAll('.var-pill').forEach(function (x) { x.classList.remove('on'); });
        this.classList.add('on');
        var h = document.querySelector('[name="id"]');
        if (h && this.dataset.vid) h.value = this.dataset.vid;
      });
    });
  });

}); // end DOMContentLoaded

// カートに追加時にヘッダーの数量を即時更新＋アニメーション
(function(){
  var origFetch = window.fetch;
  window.fetch = function(url, opts) {
    var result = origFetch.apply(this, arguments);
    var urlStr = typeof url === 'string' ? url : (url && url.url) || '';
    if (urlStr.indexOf('cart/add') !== -1) {
      result.then(function(r) {
        return r.clone().json();
      }).then(function(data) {
        if (data && !data.status) {
          // 追加成功
          fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
            var el = document.getElementById('hdr-cart-count');
            if (el) {
              el.textContent = cart.item_count;
              el.style.opacity = cart.item_count > 0 ? '1' : '0';
              el.style.transform = cart.item_count > 0 ? 'scale(1)' : 'scale(0)';
            }
            var cartBtn = document.querySelector('.hdr-cart-icon');
            if (cartBtn) {
              cartBtn.classList.remove('cart-added');
              void cartBtn.offsetWidth; // reflow
              cartBtn.classList.add('cart-added');
              setTimeout(function(){
                cartBtn.classList.remove('cart-added');
                if (el && cart.item_count > 0) {
                  el.style.opacity = '1';
                  el.style.transform = 'scale(1)';
                }
              }, 800);
            }
            // トースト通知
            var existing = document.getElementById('cart-toast');
            if (existing) existing.remove();
            var toast = document.createElement('div');
            toast.id = 'cart-toast';
            var title = data.title || '';
            toast.innerHTML = '<div class="cart-toast-check"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round"><polyline points="20 6 9 17 4 12"/></svg></div><span class="cart-toast-msg">カートに追加しました</span><a href="/cart" class="cart-toast-btn">カートへ →</a>';
            document.body.appendChild(toast);
            setTimeout(function(){ toast.classList.add('cart-toast-show'); }, 10);
            setTimeout(function(){ toast.classList.remove('cart-toast-show'); setTimeout(function(){ toast.remove(); }, 400); }, 3500);
          });
        }
      }).catch(function(){});
    }
    return result;
  };
})();

/* ページ内スクロールの位置合わせを1か所にまとめる。
   ヘッダーの高さを実測するので、バナーの有無や画面幅に関係なく揃う */
window.bringScrollTo = function (target, extra) {
  if (!target) return;
  var gap = (extra == null ? 16 : extra);

  // 目標より上にある遅延読み込みの画像を先に読み込む。
  // 移動中に高さが変わると、止まる位置がずれるため。
  var limit = target.getBoundingClientRect().top + window.pageYOffset;
  var waits = [];
  document.querySelectorAll('.rv:not(.vis)').forEach(function (el) {
    if (el.getBoundingClientRect().top + window.pageYOffset <= limit) el.classList.add('vis');
  });
  document.querySelectorAll('img[loading="lazy"]').forEach(function (im) {
    if (im.getBoundingClientRect().top + window.pageYOffset > limit) return;
    if (im.complete) return;
    im.loading = 'eager';
    waits.push(new Promise(function (done) {
      im.addEventListener('load', done, { once: true });
      im.addEventListener('error', done, { once: true });
      setTimeout(done, 600);
    }));
  });

  function go() {
    var hd = document.querySelector('.site-header');
    var hh = hd ? Math.round(hd.getBoundingClientRect().height) : 64;
    // 要素に data-scroll-offset があればその余白を足す（表を下げて上下を均等に見せる）
    var extraOffset = parseInt(target.getAttribute('data-scroll-offset') || '0', 10) || 0;
    // モバイルでは追加余白を使わない（画面が狭く、上ギリギリで止めたいため）
    if (window.matchMedia('(max-width:860px)').matches) { extraOffset = 0; }
    target.style.scrollMarginTop = (hh + gap + extraOffset) + 'px';
    try { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    catch (e) { target.scrollIntoView(true); }
  }

  if (waits.length) {
    var done = false;
    Promise.all(waits).then(function () { if (!done) { done = true; go(); } });
    setTimeout(function () { if (!done) { done = true; go(); } }, 650);
  } else {
    go();
  }
};


